'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'dove';
var width = 576;
var height = 512;
var aliases = [128330];
var unicode = 'f4ba';
var svgPathData = 'M265.9 .2c2.1 .5 4 1.9 5.1 3.8l74.8 130.3C353.9 94.2 389.4 64 432 64l112 0 2.2 .3c2.1 .6 3.9 2 4.9 4s1.2 4.3 .5 6.3l-1 2-54.6 77.9 0 125.5c0 83.9-68.1 152-152 152l-60.9 0-85.7 77.9c-2.4 2.2-5.9 2.7-8.8 1.3l-152-72c-2.8-1.3-4.6-4.2-4.6-7.3s1.9-5.9 4.8-7.2l129.4-57.5c-57.3-34.9-85.2-93.3-96-149.7-5.8-30.4-6.7-60.5-4.4-86.5 2.3-25.8 7.8-48 15.1-62.6l.9-1.4c1-1.3 2.4-2.2 4-2.7 2.1-.6 4.4-.4 6.3 .7l91.1 52.4c.8-3.2 1.7-6.3 2.6-9.4 15.3-50 47.3-89.1 73.9-106.7L261 .6c1.5-.6 3.2-.7 4.8-.3zM432 80c-39.8 0-72 32.2-72 72l0 72c0 2.9-1.5 5.5-4 6.9s-5.5 1.4-8 0L91.8 83.4c-4.6 12.1-8.3 29.1-10.1 49-2.2 24.6-1.4 53.2 4.1 82 11 57.8 40.7 115.8 101.7 146.3 2.8 1.4 4.5 4.3 4.4 7.3s-1.9 5.9-4.8 7.1l-128.1 56.9 131.4 62.2 84.1-76.4 1.2-.9c1.2-.8 2.7-1.2 4.2-1.2l64 0c75.1 0 136-60.9 136-136l0-128c0-1.6 .5-3.3 1.4-4.6L528.6 80 432 80zM261.5 19.7c-21.9 17.4-47.5 50.8-60.5 93.1-1.3 4.2-2.5 8.6-3.5 13l146.5 84.3 0-46.7-82.5-143.7zM416 176a16 16 0 1 1 0-32 16 16 0 1 1 0 32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDove = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;